import { GOFAR_SERVICE_URL, HTTP_STATUS_CODES } from './config';
import localStorageHelper from './local-storage';
import { spinnerOff, spinnerOn } from './animations';
import axios from 'axios';

const gofarService = async (url, method, data) => {
  const token = localStorageHelper.getToken();
  const fullUrl = `${GOFAR_SERVICE_URL}${url}`;
  try {
    spinnerOn();
    return await axios({
      method,
      url: fullUrl,
      headers: {
        Authorization: token
      },
      data
    });
  } catch (err) {
    switch (err.response.status) {
      case HTTP_STATUS_CODES.UNAUTHORIZED:
        localStorageHelper.clearLocalStorage();
        window.location.href = `${window.location.origin}/login`;
        break;
      case HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY:
        break;
      case HTTP_STATUS_CODES.INTERNAL_ERROR:
        console.log('Server is not responding properly.');
    }
    return err.response;
  } finally {
    spinnerOff();
  }
};
export { gofarService };
